<template>
    <div :class="isPc ? 'loading-more-pc' : 'loading-more'">
        <div class="show-more" v-if="isMore && !hide" @tap="getMore">
            展开更多
            <!-- 展开更多<img src="@/common/img/arrow.png" /> -->
        </div>
        <div v-show="loading" class="loading u-f-ajc">
            <span class="load-icon"></span>
            正在加载中…
        </div>
        <div v-show="!loading && !isMore" class="show-more">已经到底啦~</div>
    </div>
</template>

<script>
export default {
    props: ["loading", "isMore", "hide", "isPc"],
    data() {
        return {};
    },
    methods: {
        getMore() {
            this.$emit("getMore");
        },
    },
};
</script>

<style scoped lang="scss">
.loading-more {
    .show-more {
        height: 10.933vw;
        line-height: 10.933vw;
        font-size: 4.267vw;
        color: #7288a6;
        text-align: center;
        image {
            width: 5.867vw;
            height: 5.867vw;
            vertical-align: middle;
        }
    }
    .loading {
        display: flex;
        background: #fff;
        height: 10.933vw;
        align-items: center;
        justify-content: center;
        font-size: 4.267vw;
        color: #7288a6;
        .load-icon {
            display: inline-block;
            width: 0.267vw;
            height: 0.267vw;
            box-shadow: 0 -1.867vw 0 0.4vw rgba(7, 193, 96, 1),
                /*上*/ 0 1.867vw 0 0.4vw rgba(7, 193, 96, 0.6),
                /*下*/ -1.867vw 0 0 0.4vw rgba(7, 193, 96, 0.6),
                /*左*/ 1.867vw 0 0 0.4vw rgba(7, 193, 96, 0.6),
                /*右*/ -1.467vw -1.2vw 0 0.4vw rgba(7, 193, 96, 0.6),
                /*左上*/ 1.467vw -1.2vw 0 0.4vw rgba(7, 193, 96, 0.6),
                /*右上*/ -1.467vw 1.2vw 0 0.4vw rgba(7, 193, 96, 0.6),
                /*左下*/ 1.467vw 1.2vw 0 0.4vw rgba(7, 193, 96, 0.4) /*右下*/;
            border-radius: 0.133vw;
            margin-right: 4vw;
            animation: loading 2s linear 0s infinite;
            -webkit-animation: loading 2s linear 0s infinite;
            -o-animation: loading 2s linear 0s infinite;
            -moz-animation: loading 2s linear 0s infinite;
        }
    }
}

.loading-more-pc {
    .show-more {
        font-size: 26px;
        height: 100px;
        line-height: 100px;
        margin-top: 20px;
        color: #7288a6;
        text-align: center;
        image {
            width: 50px;
            height: 50px;
            vertical-align: middle;
        }
    }
    .loading {
        display: flex;
        background: #fff;
        height: 100px;
        align-items: center;
        justify-content: center;
        font-size: 26px;
        color: #7288a6;
        .load-icon {
            display: inline-block;
            width: 5px;
            height: 5px;
            box-shadow: 0 -22px 0 5px rgba(7, 193, 96, 1),
                0 22px 0 5px rgba(7, 193, 96, 0.6),
                -22px 0 0 5px rgba(7, 193, 96, 0.6),
                22px 0 0 5px rgba(7, 193, 96, 0.6),
                -17px -15px 0 5px rgba(7, 193, 96, 0.6),
                17px -15px 0 5px rgba(7, 193, 96, 0.6),
                -17px 15px 0 5px rgba(7, 193, 96, 0.6),
                17px 15px 0 5px rgba(7, 193, 96, 0.6);
            border-radius: 0.133vw;
            margin-right: 30px;
            animation: loading 2s linear 0s infinite;
            -webkit-animation: loading 2s linear 0s infinite;
            -o-animation: loading 2s linear 0s infinite;
            -moz-animation: loading 2s linear 0s infinite;
        }
    }
}

@keyframes loading {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

@-webkit-keyframes loading {
    from {
        -webkit-transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
    }
}

@-o-keyframes loading {
    from {
        -o-transform: rotate(0deg);
    }
    to {
        -o-transform: rotate(360deg);
    }
}

@-moz-keyframes loading {
    from {
        -moz-transform: rotate(0deg);
    }
    to {
        -moz-transform: rotate(360deg);
    }
}
</style>
